export default __webpack_public_path__ + "static/media/COSM492.cd0083b9.mp3";